import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';

declare const grecaptcha: any;

@Component({
  selector: 'app-captcha',
  standalone: false,
  templateUrl: './captcha.component.html'
})
export class CaptchaComponent implements AfterViewInit {

  @Input() siteKey: string = '';

  @ViewChild('captchaContainer', { static: true })
  captchaContainer!: ElementRef;

  @Output()
  resolved = new EventEmitter<string>();

  widgetId!: number;

  ngAfterViewInit(): void {
    if (
      typeof grecaptcha !== 'undefined' &&
      typeof grecaptcha.render === 'function'
    ) {
      this.renderCaptcha();
      return;
    }

    window.addEventListener(
      'recaptchaLoaded',
      () => this.renderCaptcha(),
      { once: true }
    );
  }

  private renderCaptcha(): void {
    this.widgetId = grecaptcha.render(
      this.captchaContainer.nativeElement,
      {
        sitekey: this.siteKey,
        callback: (token: string) => {
          this.resolved.emit(token);
        }
      }
    );
  }

  reset(): void {
    if (this.widgetId !== undefined) {
      grecaptcha.reset(this.widgetId);
    }
  }
}